import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import { enrolUser, userSelector, clearState } from "../../User/UserSlice";
import { useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import AuthNavBar from "../../components/nav/AuthNav";
import { enGB } from "date-fns/locale";
import { DatePicker } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import Swal from "sweetalert2";
import madagascarData from "../../../features/assets/liste_commune_par_district.json";
import { useTranslation } from "react-i18next";

const BiodataForm = () => {
  const { t, i18n } = useTranslation();
  const countryLabel = (country) => {
    try {
      return (
        new Intl.DisplayNames([i18n.language], { type: "region" }).of(
          country.code,
        ) || country.name
      );
    } catch (error) {
      return country.name;
    }
  };
  const dispatch = useDispatch();
  const { register, errors, handleSubmit } = useForm();
  const history = useHistory();

  const { isFetching, isSuccess, isError, errorMessage, successMessage } =
    useSelector(userSelector);

  const [checkedFields, setCheckedFields] = useState([]);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const [convert, setConvert] = useState("");

  function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false; // Invalid format
    var d = new Date(dateString);
    if (!d.getTime()) return false; // Invalid date (or this could be epoch)
    return d.toISOString().slice(0, 10) === dateString;
  }

  const onSubmit = (data) => {
    var firstName = data.firstName.trim();
    var lastName = data.lastName.trim();
    var dob = data.dob.trim();
    var houseAddress = data.houseAddress;
    var mydatenow = document.getElementById("dobinputtype").value;
    var nnn = mydatenow.split(/-/g);
    var newdate = [nnn[2], nnn[1], nnn[0]].join("-");
    if (firstName === "") {
      Swal.fire({
        icon: "error",
        title: t("missing_first_name"),
        text: t("missing_first_name_text"),
      });
      return;
    }
    if (lastName === "") {
      Swal.fire({
        icon: "error",
        title: t("missing_last_name"),
        text: t("missing_last_name_text"),
      });
      return;
    }

    if (dob === "") {
      Swal.fire({
        icon: "error",
        title: t("missing_dob"),
        text: t("missing_dob_text"),
      });
      return;
    }
    if (houseAddress === "") {
      Swal.fire({
        icon: "error",
        title: t("missing_house_address"),
        text: t("missing_house_address_text"),
      });
      return;
    }
    localStorage.setItem("dan", newdate);
    setHasSubmitted(true);
    dispatch(enrolUser(data));
  };

  useEffect(() => {
    dispatch(clearState());
    return () => {
      dispatch(clearState());
    };
  }, []);

  const [statesfromapi, setStatesfromapi] = useState([]);
  const [getstatesid, setGetstateid] = useState([]);
  const [getstatesoriginid, setGetstateoriginid] = useState([]);
  const [lgasfromapi, setLgasfromapi] = useState([]);
  const [lgasoriginfromapi, setLgasoriginfromapi] = useState([]);

  const [successfulresponse, setSuccessfulresponse] = useState(false);

  useEffect(() => {
    if (isError && hasSubmitted) {
      toast.error(errorMessage);
      dispatch(clearState());
      history.push("/modification");
      setHasSubmitted(false);
    }
    if (isSuccess && hasSubmitted) {
      toast.success(successMessage);
      dispatch(clearState());
      history.push("/qrgenerator");
      setHasSubmitted(false);
    }
  }, [isError, isSuccess, hasSubmitted]);

  const countries = [
    { name: "Madagascar", code: "Mg" },
    { name: "Afghanistan", code: "AF" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and Mcdonald Islands", code: "HM" },
    { name: "Holy See (Vatican City State)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia, Federated States of", code: "FM" },
    { name: "Moldova, Republic of", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Nigeria", code: "NG" },
    { name: "Niger", code: "NE" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ];

  let [caption, setCaption] = useState("House Rent");

  const inputHandler = (e) => {
    const { value, maxLength } = e.target;
    if (String(value).length >= maxLength) {
      e.preventDefault();
      return;
    }
  };
  const [isUnder18, setIsUnder18] = useState(false);
  const checkAge = (date) => {
    const today = new Date();
    const birthDate = new Date(date);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    setIsUnder18(age < 18);
  };

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [communes, setCommunes] = useState([]);

  useEffect(() => {
    setRegions(Object.keys(madagascarData));
  }, []);

  const handleRegionChange = (event) => {
    const region = event.target.value;
    setSelectedRegion(region);
    if (madagascarData[region]) {
      setDistricts(Object.keys(madagascarData[region]));
    } else {
      setDistricts([]);
    }
    setSelectedDistrict("");
    setCommunes([]);
  };

  const handleDistrictChange = (event) => {
    const district = event.target.value;
    setSelectedDistrict(district);
    if (
      madagascarData[selectedRegion] &&
      madagascarData[selectedRegion][district]
    ) {
      setCommunes(madagascarData[selectedRegion][district]);
    } else {
      setCommunes([]);
    }
  };
  useEffect(() => {
    console.log("Madagascar Data:", madagascarData);
  }, []);

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const [formattedDob, setFormattedDob] = useState("");
  const [parentDob, setParentDob] = useState("");

  return (
    <Fragment>
      <AuthNavBar />
      <div className="container">
        <h4 className="text-secondary mt-3">{t("new_enrolment")}</h4>

        <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 shadow-lg">
          <div className="card text-dark bg-light">
            <div className="card-body">
              <form
                className="space-y-6"
                onSubmit={handleSubmit(onSubmit)}
                method="POST"
              >
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <h5
                    className="card-title p-2"
                    style={{
                      backgroundColor: "rgba(10, 117, 22, 100)",
                      color: "#fff",
                    }}
                  >
                    {t("demographic_data")}
                  </h5>
                </div>

                <div className="row">
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label
                          for="exampleInputFirstName"
                          className="form-label"
                        >
                          {t("first_name")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="form-control"
                          id="firstName"
                          name="firstName"
                          type="text"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                          autocomplete="FirstName"
                        />
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label
                          for="exampleInputLastName"
                          className="form-label"
                        >
                          {t("last_name")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          className="form-control"
                          id="lastName"
                          type="text"
                          name="lastName"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                          autocomplete="lastName"
                        />
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">
                          {t("dob")} <span style={{ color: "red" }}>*</span>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          aria-describedby="DOBHelp"
                          ref={register({ required: false })}
                          id="dobinputtype"
                          name="dob"
                          onChange={(e) => {
                            const formattedDate = formatDate(e.target.value);
                            setFormattedDob(formattedDate);
                            checkAge(e.target.value);
                          }}
                        />
                        <input
                          type="text"
                          readOnly
                          hidden
                          value={formattedDob}
                          className="form-control mt-2"
                          placeholder="DD-MM-YYYY"
                        />
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">
                          {t("gender")}
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="gender"
                          name="gender"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                        >
                          <option selected>{t("select_gender")}</option>
                          <option value="male">{t("male")}</option>
                          <option value="female">{t("female")}</option>
                        </select>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">
                          {t("phone_number")}
                        </label>
                        <input
                          type="number"
                          onKeyPress={inputHandler}
                          maxlength="11"
                          placeholder="0XXXXXXXXXXX"
                          className="form-control"
                          id="exampleInputDOB"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                          name="phoneNumber"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">
                          {t("email_address")}
                        </label>
                        <input
                          className="form-control"
                          id="email"
                          name="email"
                          type="text"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                          autocomplete="Email"
                        />
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">
                          {t("maiden_name")}
                        </label>
                        <input
                          type="text"
                          onKeyPress={inputHandler}
                          maxlength="11"
                          className="form-control"
                          id="exampleInputDOB"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                          name="maidenName"
                          aria-describedby="DOBHelp"
                        />
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">
                          {t("contact_owner")}
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          id="contactOwner"
                          name="contactOwner"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                        >
                          <option selected>{t("select_contact_owner")}</option>
                          <option value="personal">{t("personal")}</option>
                          <option value="chief of fokontany">{t("chief_of_fokontany")}</option>
                          <option value="community leader">{t("community_leader")}</option>
                          <option value="other">{t("other")}</option>
                        </select>
                      </div>
                    </div>
                    {isUnder18 && (
                      <>
                        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <div className="mb-3 input-group-sm">
                            <label for="parentName" className="form-label">{t("parent_last_name")}</label>
                            <input
                              type="text"
                              className="form-control"
                              id="parentLastName"
                              name="parentLastName"
                              ref={register({ required: isUnder18 })}
                            />
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <div className="mb-3 input-group-sm">
                            <label for="parentName" className="form-label">{t("parent_first_name")}</label>
                            <input
                              type="text"
                              className="form-control"
                              id="parentFirstName"
                              name="parentFirstName"
                              ref={register({ required: isUnder18 })}
                            />
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <div className="mb-3 input-group-sm">
                            <label for="parentName" className="form-label">{t("parent_nui")}</label>
                            <input
                              type="text"
                              className="form-control"
                              id="parentNUI"
                              name="parentNUI"
                              ref={register({ required: isUnder18 })}
                            />
                          </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                          <div className="mb-3 input-group-sm">
                            <label for="exampleInputDOB" className="form-label">{t("parent_dob")}</label>

                            <input
                              type="date"
                              className="form-control"
                              aria-describedby="DOBHelp"
                              id="parentDob"
                              name="parentDob"
                              onChange={(e) => {
                                const formattedDate = formatDate(
                                  e.target.value
                                );
                                setParentDob(formattedDate);
                              }}
                              ref={register({ required: false })}
                            />
                            <input
                              type="text"
                              className="form-control mt-2"
                              value={parentDob}
                              placeholder="DD-MM-YYYY"
                              readOnly
                              hidden
                            />
                          </div>
                        </div>
                      </>
                    )}
                    <div
                      class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                      style={{ display: "none" }}
                    >
                      <div className="mb-3 input-group-sm">
                        <label for="parentName" className="form-label">{t("enrollment_type")}</label>
                        <input
                          type="text"
                          className="form-control"
                          id="enrolmentType"
                          name="enrolmentType"
                          value={isUnder18 ? "ER-NEW" : "CR-NEW"}
                          ref={register({ required: false })}
                        />
                      </div>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <h5
                      className="card-title p-2"
                      style={{
                        backgroundColor: "rgba(10, 117, 22, 100)",
                        color: "#fff",
                      }}
                    >
                      {t("residence_address_data")}
                    </h5>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">
                          {t("address")}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <textarea
                          className="form-control"
                          aria-label="With textarea"
                          name="residenceAddress"
                          id="residenceAddress"
                          style={{ textTransform: "uppercase" }}
                          ref={register({ required: false })}
                        ></textarea>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputEmail" className="form-label">{t("residence_address_town")}</label>
                        <textarea
                          className="form-control"
                          aria-label="With textarea"
                          name="houseAddress"
                          style={{ textTransform: "uppercase" }}
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label htmlFor="region" className="form-label">
                          {t("region")}
                        </label>
                        <select
                          className="form-control"
                          name="region"
                          ref={register({ required: false })}
                          id="region"
                          value={selectedRegion}
                          onChange={handleRegionChange}
                        >
                          <option value="">{t("select_region")}</option>
                          {regions.map((region) => (
                            <option key={region} value={region}>
                              {region}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label htmlFor="district" className="form-label">
                          {t("district")}
                        </label>
                        <select
                          className="form-control"
                          name="district"
                          ref={register({ required: false })}
                          id="district"
                          value={selectedDistrict}
                          onChange={handleDistrictChange}
                          disabled={!selectedRegion}
                        >
                          <option value="">{t("select_district")}</option>
                          {districts.map((district) => (
                            <option key={district} value={district}>
                              {district}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label htmlFor="commune" className="form-label">
                          {t("province")}
                        </label>
                        <select
                          className="form-control"
                          name="province"
                          ref={register({ required: false })}
                          id="province"
                          disabled={!selectedDistrict}
                        >
                          <option value="">{t("select_province")}</option>
                          {communes.map((commune) => (
                            <option key={commune} value={commune}>
                              {commune}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                      <div className="mb-3 input-group-sm">
                        <label for="exampleInputDOB" className="form-label">
                          {t("place_of_birth")}
                        </label>
                        <select
                          className="form-select"
                          aria-label="Default select example"
                          name="placeOfBirth"
                          id="placeOfBirth"
                          ref={register({ required: false })}
                          style={{ textTransform: "uppercase" }}
                        >
                          {countries
                            // .sort((a, b) => (a.timeM > b.timeM ? 1 : -1))
                            .map((country, index) => {
                              return (
                                <option key={country.name} value={country.name}>
                                  {countryLabel(country)}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-success w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  {isFetching ? (
                    <Fragment>
                      <svg
                        className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          stroke-width="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>

                      <p>{t("enrolling_user")} </p>
                    </Fragment>
                  ) : (
                    <span> {t("submit")}</span>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default BiodataForm;
